const initialState = {
    year1: 0,
    year2: 0,
    year3: 0,
  };
  const TotalYearGrossMarginPerYearReducer = (state = initialState, action) => {
    switch (action.type) {
      case "GET_TOTAL_FIXED_COST_YEAR_1":
        return { ...state, year1: action.payload };
      case "GET_TOTAL_FIXED_COST_YEAR_2":
        return { ...state, year2: action.payload };
      case "GET_TOTAL_FIXED_COST_YEAR_3":
        return { ...state, year3: action.payload };
      default:
        return state;
    }
  };
  export default TotalYearGrossMarginPerYearReducer;
  